import React from "react";
import { IconNormal } from "../../../widget/common/ui/Icon";
import AppTheme from "../../../service/app_config/AppTheme";
import { DivisionsContextImport } from "../../../provider/divisions/DivisionsContextProvider";

const DivisionstActions = () => {
  const { showSearch, updateShowSearch } = DivisionsContextImport();
  
  return (
    <>
      {!showSearch && (
        <IconNormal
          name="magnify"
          color={AppTheme.themeFont}
          handleClick={() => updateShowSearch()}
        />
      )}
    </>
  );
};

export default DivisionstActions;
